import { render, staticRenderFns } from "./FirmaDetay.vue?vue&type=template&id=ddecee7c&scoped=true&"
import script from "./FirmaDetay.vue?vue&type=script&lang=js&"
export * from "./FirmaDetay.vue?vue&type=script&lang=js&"
import style0 from "./FirmaDetay.vue?vue&type=style&index=0&id=ddecee7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddecee7c",
  null
  
)

export default component.exports